import { errorNotifier } from '@wecasa/common/src/errors/error-notifier';
import type { User } from '@wecasa/common/src/types/commons';
import { userMetaData } from '@wecasa/common/src/utils/intercom';

const updateIntercomUser = (user: User) => {
  window.Intercom('update', userMetaData(user));
};

export const connectUserToExternalSystems = (user: User) => {
  updateIntercomUser(user);
  errorNotifier.setUser(user);
};
